export default __webpack_public_path__ + "static/media/mahebeach04.c7c6c0f0.jpg";